import costuto from '@/apis/costuto.js'
const PAGINATION_SIZE = 10
const state = {
  notifications: [],
  loadedPages: 0,
  remainingNotifications: true,
  activeNotification: false
}

const getters = {
  getNotifications: state => state.notifications,
  loadedPages: state => state.loadedPages,
  remainingNotifications: state => state.remainingNotifications,
  activeNotification: state => state.activeNotification
}

const actions = {
  index: ({ commit, dispatch, rootState }, page) => {
    return new Promise((resolve, reject) => {
      costuto().get(`users/${rootState.user.attributes.username}/notifications?page=${page}`)
        .then(resp => {
          commit('incrementLoadedPages')
          console.log(resp.data.data.length)
          console.log((resp.data.data.length) < PAGINATION_SIZE)
          if ((resp.data.data.length) < PAGINATION_SIZE) { commit('setRemainingNotifications', false) }
          commit('appendNotifications', resp.data.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  addNotification: ({ commit }, notification) => {
    commit('prependNotification', notification)
  },
  activateNotification: ({ commit }) => {
    commit('activeNotification')
  },
  consultNotifications: ({ commit }) => {
    commit('consultNotifications')
  }
}

const mutations = {
  incrementLoadedPages (state) {
    state.loadedPages += 1
  },
  setRemainingNotifications (state, status) {
    state.remainingNotifications = status
  },
  appendNotifications (state, notifications) {
    state.notifications = [...new Set([...state.notifications, ...notifications])]
  },
  prependNotification (state, notification) {
    state.notifications = [...new Set([notification, ...state.notifications])]
  },
  activeNotification (state) {
    state.activeNotification = true
  },
  consultNotifications (state) {
    state.activeNotification = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
